import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "modules/common/advance-table/AdvanceTablePagination";
import AdvanceTableSearchBox from "modules/common/advance-table/AdvanceTableSearchBox";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import React from "react";
import { Col, Row } from "react-bootstrap";

function OrderStatsTable({ data }) {

  const columns = [
    {
      accessor: "type",
      Header: "No. Of Orders Placed",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "count",
      Header: "Number of Cxs",
      headerProps: { className: "text-900" },
    },
  ];

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={10}
    >
      <Row className="flex-end-center mb-3">
        <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table />
        </Col>
      </Row>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: "fs-10 mb-0 overflow-hidden",
        }}
      />
      <div className="mt-3">
        <AdvanceTablePagination table className="pagination-sm" />
      </div>
    </AdvanceTableWrapper>
  );
}

export default OrderStatsTable;
